import {computed, reactive} from 'vue';
import {loadGoogle, type PlaceApi} from '@/core/google/place-api';
import type {Prediction} from '@/core/google/type';

interface GoogleMaps {
    googleApi: PlaceApi|null;
}

const state = reactive<GoogleMaps>({
    googleApi: null
});


const useGoogleMaps = () => {
    const load = async () => {
        state.googleApi = await loadGoogle();
    }

    load();

    const googleApi = computed(() => {
        if (state.googleApi === null) {
            return {
                autocomplete: async () => {
                    return [] as Prediction[];
                }
            }
        }

        return state.googleApi;
    });

    return {googleApi};
}

export default useGoogleMaps;